<template>
  <div class="px-5 py-5 lg:px-10 xl:px-5">
    <notifications position="top center"></notifications>
    <div class="space-y-5">
      <div class="space-y-3">
        <h2 class="font-bold text-lg">Edit the impact slider</h2>
        <div>
          <label class="block text-base font-bold text-black mb-2">
            Select Campaign
          </label>
          <CampaignSearchInput />
        </div>
      </div>
      
      <template v-if="selectedCampaign">
        <div class="space-y-3">
          <div>
            <label class="block text-base font-bold text-black mb-2">
              Impact Slider Image One
            </label>
            <div class="flex flex-col md:flex-row items-start">
              <div class="w-full md:w-auto md:mr-4 mb-4 md:mb-0 uploader">
                <Uploader
                  :server="`/campaign/update-slide-one?campaign_id=${selectedCampaign?.id}`"
                  :media="sliderImageOneComputed"
                  :location="sliderGalleryLocation"
                  :maxError="'Only one image is allowed. New upload will replace the existing image.'"
                  path="/storage/media"
                  :headers="{
                    'X-CSRF-TOKEN': token,
                  }"
                  @add="addMediaHandler"
                  @remove="removeMediaHandler"
                  ref="uploaderOne"
                />
              </div>
              <div v-if="form.slider_image_one" class="w-full" :key="imageUpdateKey">
                <img :src="form.slider_image_one" :alt="'Impact Slider Image One'" class="max-w-full h-auto">
              </div>
            </div>
          </div>

          <div>
            <label for="impact_slider_slide_one_title" class="block text-base font-bold text-black">
              Impact Slider Slide One Title
            </label>
            <div class="mt-1">
              <input type="text" v-model="form.impact_slider_slide_one_title" id="impact_slider_slide_one_title" autocomplete="" class="w-full block sm:text-sm rounded-md">
            </div>
          </div>

          <div>
            <label for="impact_slider_slide_one_subtitle" class="block text-base font-bold text-black">
              Impact Slider Slide One Subtitle
            </label>
            <div class="mt-1">
              <input type="text" v-model="form.impact_slider_slide_one_subtitle" id="impact_slider_slide_one_subtitle" autocomplete="" class="w-full block sm:text-sm rounded-md">
            </div>
          </div>

          <!-- Impact Slider Slide One Text -->
          <div>
            <label class="block text-base font-bold text-black">
              Impact Slider Slide One Text
            </label>
            <div class="mt-1">
              <quill-editor
                ref="quillEditorOne"
                v-model:content="form.impact_slider_slide_one_text"
                contentType="html"
                toolbar="full"
              />
            </div>
          </div>
        </div>

        <hr>

        <div class="space-y-3">
          <div>
            <label class="block text-base font-bold text-black mb-2">
              Impact Slider Image Two
            </label>
            <div class="flex flex-col md:flex-row items-start">
              <div class="w-full md:w-auto md:mr-4 mb-4 md:mb-0 uploader">
                <Uploader
                  :server="`/campaign/update-slide-two?campaign_id=${selectedCampaign?.id}`"
                  :media="sliderImageTwoComputed"
                  :location="sliderGalleryLocation"
                  :maxError="'Only one image is allowed. New upload will replace the existing image.'"
                  path="/storage/media"
                  :headers="{
                    'X-CSRF-TOKEN': token,
                  }"
                  @add="addMediaHandlerTwo"
                  @remove="removeMediaHandlerTwo"
                  ref="uploaderTwo"
                />
              </div>
              <div v-if="form.slider_image_two" class="w-full" :key="imageUpdateKey">
                <img :src="form.slider_image_two" :alt="'Impact Slider Image Two'" class="max-w-full h-auto">
              </div>
            </div>
          </div>

          <div>
            <label for="impact_slider_slide_two_title" class="block text-base font-bold text-black">
              Impact Slider Slide Two Title
            </label>
            <div class="mt-1">
              <input type="text" v-model="form.impact_slider_slide_two_title" id="impact_slider_slide_two_title" autocomplete="" class="w-full block sm:text-sm rounded-md">
            </div>
          </div>

          <div>
            <label for="impact_slider_slide_two_subtitle" class="block text-base font-bold text-black">
              Impact Slider Slide Two Subtitle
            </label>
            <div class="mt-1">
              <input type="text" v-model="form.impact_slider_slide_two_subtitle" id="impact_slider_slide_two_subtitle" autocomplete="" class="w-full block sm:text-sm rounded-md">
            </div>
          </div>

          <!-- Impact Slider Slide Two Text -->
          <div>
            <label class="block text-base font-bold text-black">
              Impact Slider Slide Two Text
            </label>
            <div class="mt-1">
              <quill-editor
                ref="quillEditorTwo"
                v-model:content="form.impact_slider_slide_two_text"
                contentType="html"
                toolbar="full"
              />
            </div>
          </div>
        </div>

        <hr>

        <div class="space-y-3">
          <div>
            <label class="block text-base font-bold text-black mb-2">
              Impact Slider Image Three
            </label>
            <div class="flex flex-col md:flex-row items-start">
              <div class="w-full md:w-auto md:mr-4 mb-4 md:mb-0 uploader">
                <Uploader
                  :server="`/campaign/update-slide-three?campaign_id=${selectedCampaign?.id}`"
                  :media="sliderImageThreeComputed"
                  :location="sliderGalleryLocation"
                  :maxError="'Only one image is allowed. New upload will replace the existing image.'"
                  path="/storage/media"
                  :headers="{
                    'X-CSRF-TOKEN': token,
                  }"
                  @add="addMediaHandlerThree"
                  @remove="removeMediaHandlerThree"
                  ref="uploaderThree"
                />
              </div>
              <div v-if="form.slider_image_three" class="w-full" :key="imageUpdateKey">
                <img :src="form.slider_image_three" :alt="'Impact Slider Image Three'" class="max-w-full h-auto">
              </div>
            </div>
          </div>

          <div>
            <label for="impact_slider_slide_three_title" class="block text-base font-bold text-black">
              Impact Slider Slide Three Title
            </label>
            <div class="mt-1">
              <input type="text" v-model="form.impact_slider_slide_three_title" id="impact_slider_slide_three_title" autocomplete="" class="w-full block sm:text-sm rounded-md">
            </div>
          </div>

          <div>
            <label for="impact_slider_slide_three_subtitle" class="block text-base font-bold text-black">
              Impact Slider Slide Three Subtitle
            </label>
            <div class="mt-1">
              <input type="text" v-model="form.impact_slider_slide_three_subtitle" id="impact_slider_slide_three_subtitle" autocomplete="" class="w-full block sm:text-sm rounded-md">
            </div>
          </div>

          <!-- Impact Slider Slide Three Text -->
          <div>
            <label class="block text-base font-bold text-black">
              Impact Slider Slide Three Text
            </label>
            <div class="mt-1">
              <quill-editor
                ref="quillEditorThree"
                v-model:content="form.impact_slider_slide_three_text"
                contentType="html"
                toolbar="full"
              />
            </div>
          </div>
        </div>

        <!-- Hidden Fields -->
        <input type="hidden" v-model="form.name" />
        <input type="hidden" v-model="form.goal" />

        <div class="flex space-x-3 mt-4">
          <!-- Save Button -->
          <button @click="updateCampaign" type="button" class="inline-flex items-center text-center text-sm uppercase px-6 py-3 border-2 border-transparent font-medium shadow-sm text-white bg-green-500 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-200 rounded-full">
            <i class="fas fa-check mr-2"></i> Save
          </button>

          <!-- Cancel Button (as a link) -->
          <a href="/" class="inline-flex items-center text-center text-sm uppercase px-6 py-3 border-2 border-transparent font-medium shadow-sm text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-200 rounded-full">
            <i class="fas fa-ban mr-2"></i> Cancel
          </a>
        </div>
      </template>
      
      <div v-else class="text-center py-8 text-gray-500">
        Please select a campaign to edit its impact slider
      </div>
    </div>
  </div>
</template>

<script>
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import Uploader from 'vue-media-upload';
import CampaignSearchInput from '../campaigns/CampaignSearchInput.vue';

export default {
  name: 'ImpactSlider',
  components: {
    QuillEditor,
    Uploader,
    CampaignSearchInput
  },
  data() {
    return {
      selectedCampaign: null,
      form: {
        slider_image_one: '',
        slider_image_two: '',
        slider_image_three: '',
        impact_slider_slide_one_title: '',
        impact_slider_slide_two_title: '',
        impact_slider_slide_three_title: '',
        impact_slider_slide_one_subtitle: '',
        impact_slider_slide_two_subtitle: '',
        impact_slider_slide_three_subtitle: '',
        impact_slider_slide_one_text: '',
        impact_slider_slide_two_text: '',
        impact_slider_slide_three_text: '',
        name: '',
        goal: '',
      },
      sliderGalleryLocation: '',
      media: {
        saved: [],
        added: [],
        removed: []
      },
      imageUpdateKey: 0,
      imageLoading: {
        one: false,
        two: false,
        three: false
      }
    }
  },
  created() {
    this.emitter.on('search-selected-campaign', this.handleCampaignSelect);
  },
  beforeUnmount() {
    this.emitter.off('search-selected-campaign', this.handleCampaignSelect);
  },
  computed: {
    token() {
      return document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    },
    sliderImageOneComputed() {
      return this.form.slider_image_one ? [{ name: this.form.slider_image_one.split('/').pop() }] : [];
    },
    sliderImageTwoComputed() {
      return this.form.slider_image_two ? [{ name: this.form.slider_image_two.split('/').pop() }] : [];
    },
    sliderImageThreeComputed() {
      return this.form.slider_image_three ? [{ name: this.form.slider_image_three.split('/').pop() }] : [];
    }
  },
  methods: {
    handleCampaignSelect(campaign) {
      this.selectedCampaign = campaign;
      if (campaign) {
        this.getCampaign();
      }
    },
    updateImagePreview() {
      this.imageUpdateKey += 1;
      this.$forceUpdate();
    },
    getCampaign() {
      if (!this.selectedCampaign) return;
      
      axios.get(`/campaign/${this.selectedCampaign.id}`)
        .then(response => {
          const campaign = response.data.campaign;
          this.form.slider_image_one = campaign.slider_image_one ?? '';
          this.form.slider_image_two = campaign.slider_image_two ?? '';
          this.form.slider_image_three = campaign.slider_image_three ?? '';
          this.form.impact_slider_slide_one_title = campaign.impact_slider_slide_one_title ?? '';
          this.form.impact_slider_slide_two_title = campaign.impact_slider_slide_two_title ?? '';
          this.form.impact_slider_slide_three_title = campaign.impact_slider_slide_three_title ?? '';
          this.form.impact_slider_slide_one_subtitle = campaign.impact_slider_slide_one_subtitle ?? '';
          this.form.impact_slider_slide_two_subtitle = campaign.impact_slider_slide_two_subtitle ?? '';
          this.form.impact_slider_slide_three_subtitle = campaign.impact_slider_slide_three_subtitle ?? '';
          this.form.impact_slider_slide_one_text = campaign.impact_slider_slide_one_text ?? '';
          this.form.impact_slider_slide_two_text = campaign.impact_slider_slide_two_text ?? '';
          this.form.impact_slider_slide_three_text = campaign.impact_slider_slide_three_text ?? '';
          this.form.name = campaign.name ?? '';
          this.form.goal = campaign.goal ?? '';

          const firstImage = campaign.slider_image_one || campaign.slider_image_two || campaign.slider_image_three;
          if (firstImage) {
            try {
              const url = new URL(firstImage);
              this.sliderGalleryLocation = url.origin + url.pathname.substring(0, url.pathname.lastIndexOf('/'));
            } catch (e) {
              this.sliderGalleryLocation = window.location.origin + '/storage/media';
            }
          }
        })
        .catch(error => {
          this.$notify({ text: 'Failed to fetch campaign data', type: 'error' });
        });
    },
    updateCampaign() {
      if (!this.selectedCampaign) {
        this.$notify({ text: 'Please select a campaign first', type: 'error' });
        return;
      }

      // Create a payload with just the impact slider related fields and required fields
      const payload = {
        name: this.form.name,
        goal: this.form.goal,
        impact_slider_slide_one_title: this.form.impact_slider_slide_one_title,
        impact_slider_slide_two_title: this.form.impact_slider_slide_two_title,
        impact_slider_slide_three_title: this.form.impact_slider_slide_three_title,
        impact_slider_slide_one_subtitle: this.form.impact_slider_slide_one_subtitle,
        impact_slider_slide_two_subtitle: this.form.impact_slider_slide_two_subtitle,
        impact_slider_slide_three_subtitle: this.form.impact_slider_slide_three_subtitle,
        impact_slider_slide_one_text: this.form.impact_slider_slide_one_text,
        impact_slider_slide_two_text: this.form.impact_slider_slide_two_text,
        impact_slider_slide_three_text: this.form.impact_slider_slide_three_text,
        slider_image_one: this.form.slider_image_one,
        slider_image_two: this.form.slider_image_two,
        slider_image_three: this.form.slider_image_three
      };

      // Add CSRF token to headers
      const headers = {
        'X-CSRF-TOKEN': this.token,
        'Content-Type': 'application/json'
      };

      axios.post(`/update-campaign/${this.selectedCampaign.id}`, payload, { headers })
        .then(response => {
          if (response.data.type === 'success') {
            this.$notify({ text: 'Campaign has been updated.', type: 'success' });
          } else {
            this.$notify({ text: response.data.message || 'Update failed', type: 'error' });
          }
        })
        .catch(error => {
          console.error('Update campaign error:', error.response?.data || error);
          this.$notify({ 
            text: `Failed to update campaign: ${error.response?.data?.message || error.message || 'Unknown error'}`, 
            type: 'error' 
          });
        });
    },
    addMediaHandler(addedImage, addedMedia) {
      if (addedImage && addedImage.url && addedImage.url.startsWith('blob:')) {
        this.imageLoading.one = true;
        
        fetch(addedImage.url)
          .then(response => response.blob())
          .then(blob => {
            const formData = new FormData();
            const file = new File([blob], `image.${addedImage.type.split('/')[1]}`, { type: addedImage.type });
            formData.append('image', file);
            formData.append('campaign_id', this.selectedCampaign.id);

            return axios.post('/campaign/update-slide-one', formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
                'X-CSRF-TOKEN': this.token
              }
            });
          })
          .then(response => {
            if (response.data.url) {
              const img = new Image();
              img.onload = () => {
                this.$nextTick(() => {
                  this.form.slider_image_one = response.data.url;
                  this.updateImagePreview();
                  this.imageLoading.one = false;
                  this.$notify({ text: 'Image uploaded successfully', type: 'success' });
                });
              };
              img.src = response.data.url;
            } else {
              this.imageLoading.one = false;
              throw new Error('Server response missing URL');
            }
          })
          .catch(error => {
            this.imageLoading.one = false;
            this.$notify({ 
              text: `Upload failed: ${error.response?.data?.message || error.message}`, 
              type: 'error' 
            });
          });
      } else if (addedImage && addedImage.file) {
        this.imageLoading.one = true;
        const formData = new FormData();
        formData.append('image', addedImage.file);
        formData.append('campaign_id', this.selectedCampaign.id);

        axios.post('/campaign/update-slide-one', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-CSRF-TOKEN': this.token
          }
        })
        .then(response => {
          if (response.data.url) {
            const img = new Image();
            img.onload = () => {
              this.$nextTick(() => {
                this.form.slider_image_one = response.data.url;
                this.updateImagePreview();
                this.imageLoading.one = false;
                this.$notify({ text: 'Image uploaded successfully', type: 'success' });
              });
            };
            img.src = response.data.url;
          } else {
            this.imageLoading.one = false;
            throw new Error('Server response missing URL');
          }
        })
        .catch(error => {
          this.imageLoading.one = false;
          this.$notify({ 
            text: `Upload failed: ${error.response?.data?.message || error.message}`, 
            type: 'error' 
          });
        });
      } else {
        this.$notify({ 
          text: 'Invalid image data received', 
          type: 'error' 
        });
      }
    },
    addMediaHandlerTwo(addedImage, addedMedia) {
      if (addedImage && addedImage.url && addedImage.url.startsWith('blob:')) {
        this.imageLoading.two = true;
        
        fetch(addedImage.url)
          .then(response => response.blob())
          .then(blob => {
            const formData = new FormData();
            const file = new File([blob], `image.${addedImage.type.split('/')[1]}`, { type: addedImage.type });
            formData.append('image', file);
            formData.append('campaign_id', this.selectedCampaign.id);

            return axios.post('/campaign/update-slide-two', formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
                'X-CSRF-TOKEN': this.token
              }
            });
          })
          .then(response => {
            if (response.data.url) {
              const img = new Image();
              img.onload = () => {
                this.$nextTick(() => {
                  this.form.slider_image_two = response.data.url;
                  this.updateImagePreview();
                  this.imageLoading.two = false;
                  this.$notify({ text: 'Image uploaded successfully', type: 'success' });
                });
              };
              img.src = response.data.url;
            } else {
              this.imageLoading.two = false;
              throw new Error('Server response missing URL');
            }
          })
          .catch(error => {
            this.imageLoading.two = false;
            this.$notify({ 
              text: `Upload failed: ${error.response?.data?.message || error.message}`, 
              type: 'error' 
            });
          });
      } else if (addedImage && addedImage.file) {
        this.imageLoading.two = true;
        const formData = new FormData();
        formData.append('image', addedImage.file);
        formData.append('campaign_id', this.selectedCampaign.id);

        axios.post('/campaign/update-slide-two', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-CSRF-TOKEN': this.token
          }
        })
        .then(response => {
          if (response.data.url) {
            const img = new Image();
            img.onload = () => {
              this.$nextTick(() => {
                this.form.slider_image_two = response.data.url;
                this.updateImagePreview();
                this.imageLoading.two = false;
                this.$notify({ text: 'Image uploaded successfully', type: 'success' });
              });
            };
            img.src = response.data.url;
          } else {
            this.imageLoading.two = false;
            throw new Error('Server response missing URL');
          }
        })
        .catch(error => {
          this.imageLoading.two = false;
          this.$notify({ 
            text: `Upload failed: ${error.response?.data?.message || error.message}`, 
            type: 'error' 
          });
        });
      } else {
        this.$notify({ 
          text: 'Invalid image data received', 
          type: 'error' 
        });
      }
    },
    addMediaHandlerThree(addedImage, addedMedia) {
      if (addedImage && addedImage.url && addedImage.url.startsWith('blob:')) {
        this.imageLoading.three = true;
        
        fetch(addedImage.url)
          .then(response => response.blob())
          .then(blob => {
            const formData = new FormData();
            const file = new File([blob], `image.${addedImage.type.split('/')[1]}`, { type: addedImage.type });
            formData.append('image', file);
            formData.append('campaign_id', this.selectedCampaign.id);

            return axios.post('/campaign/update-slide-three', formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
                'X-CSRF-TOKEN': this.token
              }
            });
          })
          .then(response => {
            if (response.data.url) {
              const img = new Image();
              img.onload = () => {
                this.$nextTick(() => {
                  this.form.slider_image_three = response.data.url;
                  this.updateImagePreview();
                  this.imageLoading.three = false;
                  this.$notify({ text: 'Image uploaded successfully', type: 'success' });
                });
              };
              img.src = response.data.url;
            } else {
              this.imageLoading.three = false;
              throw new Error('Server response missing URL');
            }
          })
          .catch(error => {
            this.imageLoading.three = false;
            this.$notify({ 
              text: `Upload failed: ${error.response?.data?.message || error.message}`, 
              type: 'error' 
            });
          });
      } else if (addedImage && addedImage.file) {
        this.imageLoading.three = true;
        const formData = new FormData();
        formData.append('image', addedImage.file);
        formData.append('campaign_id', this.selectedCampaign.id);

        axios.post('/campaign/update-slide-three', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-CSRF-TOKEN': this.token
          }
        })
        .then(response => {
          if (response.data.url) {
            const img = new Image();
            img.onload = () => {
              this.$nextTick(() => {
                this.form.slider_image_three = response.data.url;
                this.updateImagePreview();
                this.imageLoading.three = false;
                this.$notify({ text: 'Image uploaded successfully', type: 'success' });
              });
            };
            img.src = response.data.url;
          } else {
            this.imageLoading.three = false;
            throw new Error('Server response missing URL');
          }
        })
        .catch(error => {
          this.imageLoading.three = false;
          this.$notify({ 
            text: `Upload failed: ${error.response?.data?.message || error.message}`, 
            type: 'error' 
          });
        });
      } else {
        this.$notify({ 
          text: 'Invalid image data received', 
          type: 'error' 
        });
      }
    },
    removeMediaHandler(removedImage, removedMedia) {
      this.form.slider_image_one = '';
      this.updateImagePreview();
      this.$notify({ text: 'Image removed', type: 'success' });
    },
    removeMediaHandlerTwo(removedImage, removedMedia) {
      this.form.slider_image_two = '';
      this.updateImagePreview();
      this.$notify({ text: 'Image removed', type: 'success' });
    },
    removeMediaHandlerThree(removedImage, removedMedia) {
      this.form.slider_image_three = '';
      this.updateImagePreview();
      this.$notify({ text: 'Image removed', type: 'success' });
    }
  }
}
</script>

<style scoped>
.uploader {
  position: relative;
}

.uploader.loading::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.7);
  display: block;
  pointer-events: none;
}

.uploader.loading {
  opacity: 0.7;
  cursor: wait;
}
</style>
